(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const headerSearchToggle = document.querySelectorAll('[data-header-search-toggle]');
    const headerSearch = document.querySelector('[data-header-search]');
    const searchInput = headerSearch.querySelector('#Search');
    const searchActions = document.querySelector('[data-search-actions]');
    const hideOnSearch = document.querySelectorAll('[data-hide-on-search]');

    headerSearchToggle.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        headerSearch.classList.toggle('hidden');
        if (!headerSearch.classList.contains('hidden')) {
          // Focus the search input after a brief delay to ensure the element is visible
          setTimeout(() => {
            searchInput.focus();
          }, 100);
          document.body.classList.add('active-search');
          setTimeout(() => {
            searchInput.closest('.extending--border').classList.add('extending--border-active');
          }, 100);
        } else {
          document.body.classList.remove('active-search');
          searchInput.closest('.extending--border').classList.remove('extending--border-active');
        }
        searchActions.classList.toggle('hidden');
        hideOnSearch.forEach((el) => {
          el.classList.toggle('!hidden');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
